<section class="bg-black text-white py-6">
  <div class="container">
    <div class="row align-items-end">
      <div class="col-md-6 text-center text-md-start mb-4 mb-md-0">
        <h2 class="h4 text-white">Subscribe to Our Newsletter</h2>
        <p class="mb-0">
          Get the things you need in your email including resources, discount products for your next fundraisers and
          more.
        </p>
      </div>
      <div class="col-md-6">
        <p *ngIf="showMessage" class="text-center text-success">
          {{ errorMessage || 'Thank you for your submission!' }}
        </p>
        <form
          (ngSubmit)="onSubmit()"
          [class.loading]="submitPending"
          [formGroup]="form"
          class="input-group input-group-lg input-group-rounded"
        >
          <input
            aria-label="Enter Your Email Here"
            class="form-control shadow-bottom-sm"
            formControlName="email"
            placeholder="Enter Your Email Here"
            type="email"
          />
          <button
            [disabled]="submitPending"
            class="btn btn-primary text-uppercase d-flex shadow-bottom-sm"
            type="submit"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
